// LOCAL STORAGE
function getLocalStorageArray(key ) {
    var array = JSON.parse( localStorage.getItem(key) );

    if ( !array ) {
        array = [];
    }

    return array;
}

function setLocalStorageArray( key, array ) {
    localStorage.setItem( key, JSON.stringify( array ));
}